var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7536 7.62253L8.8811 12.4632L13.7218 17.3039L11.302 22.6304M15.548 6.13931C16.169 6.13931 16.7645 5.89263 17.2036 5.45355C17.6427 5.01447 17.8893 4.41894 17.8893 3.79799C17.8893 3.17703 17.6427 2.5815 17.2036 2.14242C16.7645 1.70334 16.169 1.45667 15.548 1.45667C14.9271 1.45667 14.3315 1.70334 13.8925 2.14242C13.4534 2.5815 13.2067 3.17703 13.2067 3.79799C13.2067 4.41894 13.4534 5.01447 13.8925 5.45355C14.3315 5.89263 14.9271 6.13931 15.548 6.13931Z",
    stroke: "#E83855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49202 9.0744L9.45705 5.20068L12.7536 7.62161L16.1427 11.4942H20.4999M8.3976 16.3348L6.94481 17.303H3.07227",
    stroke: "#E83855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.9d23877a909488b28d400d6e8fbb8fb9.svg";
export { ForwardRef as ReactComponent };